import { render } from "inferno";
import { App } from "./App";

render(<App />, document.querySelector("#app"));



// WEBPACK FOOTER //
// ./src/index.js